/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportJobDto } from '../../models/export-job-dto';

export interface ExportsExportJobIdGet$Json$Params {
  exportJobId: string;
}

export function exportsExportJobIdGet$Json(http: HttpClient, rootUrl: string, params: ExportsExportJobIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportJobDto>> {
  const rb = new RequestBuilder(rootUrl, exportsExportJobIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('exportJobId', params.exportJobId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportJobDto>;
    })
  );
}

exportsExportJobIdGet$Json.PATH = '/exports/{exportJobId}';
